const columns = [
  {
    name: 'Color',
    selector: (row) => row.name,
  },
  {
    name: 'Color Code',
    selector: (row) => <>
      <h2 className="flex items-center">
        <span
          className="w-[20px] h-[20px] inline-block mr-2"
          style={{ backgroundColor: row.code }}
        ></span>
        {row.code}
      </h2>
    </>
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
